import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import AOS from 'aos'
import MetaInfo from '@/components/common/MetaInfo'
import Breadcrumb from '@common/Breadcrumb'
import Button from '@ui/Button'
import { ROUTES,SITE } from '@/constants'
import { useTreeAnimation } from '@helpers/useIntersectionObserver'
 import { buildRows } from '../assets/js/common'
 import { metaTitleFor } from '../assets/js/navBreadcrumb'
 const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.CAREERS)
 
/* ── Floating hexagon tag data ── */
// const FLOAT_TAGS = [
//   { label: 'Integrity',    delay: 0,    x: '12%',  y: '20%', dur: 7 },
//   { label: 'Passion',      delay: 1.2,  x: '78%',  y: '15%', dur: 9 },
//   { label: 'Excellence',   delay: 0.6,  x: '68%',  y: '72%', dur: 8 },
//   { label: 'Innovation',   delay: 2,    x: '18%',  y: '68%', dur: 10 },
//  { label: 'Team Spirit',  delay: 1.6,  x: '45%',  y: '82%', dur: 6.5 },
    
// ]

const Non_IT = [
  { name: 'Business Development Executive',    color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'IT Sales / Pre Sales Experts',    color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Digital Marketing Experts',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
  ]
  const non_ITRows = buildRows(Non_IT)

  
const IT = [
 
  { name: 'Full Stack / Front End / Back End Engineers',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
  { name: 'AI/ML Engineers',     color: { bg: '#ece3d0', text: '#5c4a1e' } },
  { name: 'DevOps Engineer',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
  { name: 'Software Testing Engineers',   color: { bg: '#dbd1fc', text: '#4a2d8a' } },
  { name: 'Business Analysts', color: { bg: '#f7d3cf', text: '#7a3228' } },
  { name: 'Project Manager / Team Leads',        color: { bg: '#9bcf60', text: '#2e5a0e' } },
  ]
  const ITRows = buildRows(IT)

// function buildRows(items) {
//   const rows = []
//   let i = 0, rowIndex = 0
//   while (i < items.length) {
//     const size = rowIndex % 2 === 0 ? 6 : 5
//     rows.push(items.slice(i, i + size))
//     i += size
//     rowIndex++
//   }
//   return rows
// }

// const PERFORMANCE_AREAS = [
//   { name: 'Integrity',    color: { bg: '#f7d3cf', text: '#7a3228' } },
//   { name: 'Passion',     color: { bg: '#9bcf60', text: '#2e5a0e' } },
//   { name: 'Excellence',       color: { bg: '#7fc2eb', text: '#1a4f72' } },
//   { name: 'Innovation',     color: { bg: '#a9e5e5', text: '#1a5c5c' } },
//   { name: 'Team Spirit',   color: { bg: '#dbd1fc', text: '#4a2d8a' } }, 
// ]
const PERFORMANCE_AREAS = [
  { icon: 'fa-handshake',    title: 'Integrity' },
  { icon: 'fa-fire',         title: 'Passion' },
  { icon: 'fa-award',        title: 'Excellence' },
  { icon: 'fa-lightbulb',    title: 'Innovation' },
  { icon: 'fa-people-group', title: 'Team Spirit' },
]

// Stable reference for useTreeAnimation
const TREE_BRANCH_IDS = [
  'culture-branch-1',
  'culture-branch-2',
  'culture-branch-3',
  'culture-branch-4',
  'culture-branch-5',
]
export default function CultureValues() {
  useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
  useTreeAnimation('culture-travel-dot', TREE_BRANCH_IDS, 600)
  return (
    <>
      {/* <MetaInfo
        title="Careers At CruxBytes | CruxBytes Consultancy Services"
        description="Discover the culture, values, and people principles that define CruxBytes — a workplace built on integrity, passion, excellence, and team spirit."
        keywords="CruxBytes culture, company values, team spirit, integrity, innovation, excellence"
      /> */}
       <MetaInfo
            title={`${label} ${SITE.metaTagPostText}`} 
            description={metaDesc}
            keywords=""
            />
      <main id="main-content" className="page-wrapper">

        {/* ── Page Hero ── */}
        <div className="page-hero">
          <div className="bg-grid bg-grid--fill" aria-hidden="true" />
          <div className="container">
            <Breadcrumb />
            <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* Careers At CruxBytes */}
              {label}</h1>
            <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
              {/* Our culture and values shape who we are and guide everything we do.
              We foster a learning-driven environment where our people can grow,
              strengthen their skills, and contribute to our mission of delivering
              meaningful innovation. */}
              {pageDesc}
            </p>
            <div className="inner-page-actions">
              <Button href={ROUTES.APPLY_FOR_JOB} variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                Join Our Team
              </Button>
            </div>
          </div>
        </div>

        {/* ── Section 1 — Passion Drives Performance + Floating Hex Tags ── */}
        <section className="cv-passion-section section-py bg-linear-gradient-light text-center" aria-labelledby="policy-root-node" >
          {/* floating tags rendered behind content */}
          {/* <div className="cv-hex-field" aria-hidden="true">
            {FLOAT_TAGS.map((tag) => (
              <span
                key={tag.label}
                className="cv-hex-tag"
                style={{
                  left: tag.x,
                  top: tag.y,
                  animationDuration: `${tag.dur}s`,
                  animationDelay: `${tag.delay}s`,
                  '--hex-color': tag.color,
                }}
              >
                {tag.label}
              </span>
            ))}
          </div> */}

          <div className="container cv-passion-content" data-aos="fade-up">
            {/* <span className="section-label section-label-small">Our Culture</span> */}
            {/* <h2 id="cv-passion-heading" className="no-reveal">
              Passion Drives Performance
            </h2> */}
            <p>
              We recognise young talents, nurture them and take them to the
              highest level to ensure they perform beyond their expectations.
              We provide the environment and adequate opportunities to scale
              at their own pace and polish the qualities they naturally carry.
            </p>
          </div>
        
              <div className="policy-tree-section">
  <div>
    <span className="policy-root" id="policy-root-node" data-aos="fade-up">
      Passion Drives Performance
    </span>
  </div>

  <div className="policy-tree-connector" data-aos="fade-up" data-aos-delay={100}>
    <svg
    viewBox="0 0 1200 140"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden="true"
  >
    <path
      id="culture-branch-1"
      className="branch-line"
      d="M 600,0 L 600,45 Q 600,70 550,70 L 130,70 Q 110,70 110,95 L 110,140"
    />
    <path
      id="culture-branch-2"
      className="branch-line"
      d="M 600,0 L 600,45 Q 600,70 570,70 L 375,70 Q 355,70 355,95 L 355,140"
    />
    <path
      id="culture-branch-3"
      className="branch-line"
      d="M 600,0 L 600,140"
    />
    <path
      id="culture-branch-4"
      className="branch-line"
      d="M 600,0 L 600,45 Q 600,70 630,70 L 825,70 Q 845,70 845,95 L 845,140"
    />
    <path
      id="culture-branch-5"
      className="branch-line"
      d="M 600,0 L 600,45 Q 600,70 650,70 L 1070,70 Q 1090,70 1090,95 L 1090,140"
    />

    <circle
      className="travel-dot"
      id="culture-travel-dot"
      cx="600"
      cy="0"
      r="5"
    />
  </svg>
</div>

   <div className="policy-cards-row policy-cards-row--four policy-cards-row--five">
   {PERFORMANCE_AREAS.map((step, i) => (
  <div className="policy-card" key={step.title} data-aos="fade-up" data-aos-delay={i * 100}>
    
    <span className="sc-bullet-icon" aria-hidden="true">
      <i className={`fa-solid ${step.icon}`} />
    </span>
    <span>{step.title}</span>
  </div>
))}
  </div>
</div>
        </section>

        {/* ── Section 2 — What We Stand For ── */}
        <section className="bgs-section bgs-section--tint section-py" aria-labelledby="sc-code-heading">

  {/* Decorative curves — top left */}

  <div className="container">

    {/* Heading */}
    <div className="sc-code-header" data-aos="fade-up">
      <h2 id="sc-code-heading" className="sc-code-heading">
        Culture & Values
      </h2>
    </div>

    {/* 4 columns */}
    <div className="sc-code-grid">
      {[
        {
          icon: 'fa-brain',
          title: 'Innovative Thought Process',
          desc: 'We approach every challenge with curiosity, creativity, and a willingness to think beyond conventional solutions. We continuously explore emerging technologies and new ideas to create smarter, more effective solutions for our clients.',
        },
        {
          icon: 'fa-trophy',
          title: 'Delivery Par Excellence',
          desc: 'We believe great ideas matter only when they are executed well. Our focus is on delivering reliable, high-quality solutions with attention to detail, clear communication, and a strong commitment to timelines and business objectives.',
        },
        {
          icon: 'fa-shield-heart',
          title: 'Integrity & Confidentiality',
          desc: 'Trust is at the core of every relationship we build. We operate with honesty, transparency, and accountability while treating our clients data, ideas, intellectual property, and business information with the highest level of confidentiality.',
        },
        {
          icon: 'fa-bullseye',
          title: 'Client-Centric Partnership',
          desc: 'We work as an extension of our clients teams, taking the time to understand their goals, challenges, and priorities. Our success is measured by the value we create and the long-term relationships we build.',
        },
      ].map((item, i) => (
        <div
          key={item.title}
          className="sc-code-col"
          data-aos="fade-up"
          data-aos-delay={i * 80}
        >
          {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
          <i className={`fa-solid ${item.icon} sc-code-icon`} aria-hidden="true" />
          <h3 className="sc-code-title">{item.title}</h3>
          <p className="sc-code-desc">{item.desc}</p>
        </div>
      ))}
    </div>

  </div>
</section>

        {/* ── Section 3 — Investing in People ── */}
        <section className="section-py text-center"  aria-label="Investing in our people" data-aos="fade-up">
          <div className="container">
            <p>
              By investing in our people, embracing diversity, and staying true to our values and social responsibilities, we strive to build a workplace where our team feels valued, empowered, and proud to belong — while bringing the right talent and expertise to every client engagement.            </p>
            
          </div>
       
          <div className="container">
            <div style={{padding:'2rem 0 3rem'}}>
             <h4 id="cv-passion-heading" className="no-reveal" data-aos="fade-up" >
              Non-IT Related Hirings

            </h4>
            <div className="domain-grid " aria-label="List of industries we serve">
                {non_ITRows.map((row, rowIdx) => (
                  <div key={rowIdx} className="domain-row">
                    {row.map((domain, chipIdx) => (
                      <span
                        key={domain.name}
                        className="domain-chip"
                        style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                        data-aos="fade-up"
                        data-aos-delay={chipIdx * 30}
                      >
                        {domain.name}
                      </span>
                    ))}
                  </div>
                ))}
              </div></div>
             <h4 id="cv-passion-heading" className="no-reveal" data-aos="fade-up" >
              IT Related Hirings
            </h4>
              <div className="domain-grid" aria-label="List of industries we serve">
                {ITRows.map((row, rowIdx) => (
                  <div key={rowIdx} className="domain-row">
                    {row.map((domain, chipIdx) => (
                      <span
                        key={domain.name}
                        className="domain-chip"
                        style={{ '--chip-bg': domain.color.bg, '--chip-text': domain.color.text }}
                        data-aos="fade-up"
                        data-aos-delay={chipIdx * 30}
                      >
                        {domain.name}
                      </span>
                    ))}
                  </div>
                ))}
              </div>
            
          </div>
        </section>
        {/* ── Section 5 — Career CTA Banner ── */}
        
 <section   style={{backgroundColor: '#484389'}}>      
      
           <div className="comparison-intro" style={{ padding: '3rem 4.5rem 3rem 4.5rem', marginBottom:'0rem'}}>
  <div><h5 className="impact-desc comparison-intro-text" style={{color:'#fff'}} data-aos="fade-left" >Submit your CV and we will reach out as soon as a relevant opening comes up. Great careers are built on great teams.</h5></div>

  <div className="wcs-actions comparison-intro-cta" data-aos="fade-right" >
    <Button  href={ROUTES.APPLY_FOR_JOB}  variant="secondary" icon="fa-arrow-right" iconPos="right">
       Join Our Team
    </Button>
  </div>
</div>
    </section>
      </main>
    </>
  )
}